/**
 * 消息模块路由
 *
 * 独立消息中心页只挂在个人中心（getUserRoutes），不要再 default-export
 * 同一条记录，否则会与 /profile/messages 同名冲突。
 */
import type { RouteRecordRaw } from 'vue-router'

export const profileMessagesRoute: RouteRecordRaw = {
  path: 'messages',
  name: 'ProfileMessages',
  component: () => import('@/modules/message/views/MessageCenter.vue'),
  meta: {
    titleKey: 'menu.messageCenter',
    title: '消息中心',
    requiresAuth: true,
    breadcrumb: true
  }
}

const messageRoutes: RouteRecordRaw[] = []

export default messageRoutes
